/*
Sohel  12/21/2022 3075154998 Added Record Format Fields Screen
Sohel  12/21/2022 3075154998 field length changes.
Sohel  12/22/2022 3075154998 Integrated Record Format Fields API
Sohel 12/27/2022 3075154998 record Format Fields Added validation
Sohel 12/27/2022 3075154998 Added Field Name Validation
Sohel 12/29/2022 3075154998 Fixed  Validation issue.
Sohel 12/29/2022 3075154998 Fixed  Field Header Prepopulate issue.
Sohel 01/03/2023 2701323910 payload Changes
Sohel 01/04/2022 2698964415 payload Changes
Sai maheshwar 01/06/2023 2701334326 added function lookup
Sohel 01/09/2023 2698964415 pass selected category in table Payload
dilip 01/10/2023 2698964415 Added unsaved popup.
Sohel 01/10/2023 2698964415 Added isEditable Props.
Sohel 01/10/2023 2698964415 changed Back button condition
Sai maheshwar 01/11/2023 2701326866, 2699389646 added function lookup
Suresh Peddavoora 01/11/2023 2698964415 Fixed Button Spacing Alignments
dilip 01/12/2023 2698964415 Get Mapped Records API changes.
Sohel 01/13/2023 2698964415 added conditionally staging repository
Ashraf 01/13/2023 2698964415 fixed inappropriate text.
Sohel 01/13/2023 2698964415 fixed dataType payload Issue
Ashraf 01/13/2023 2698964415 fixed toast messages and loaders
Sai maheshwar 01/13/2023 2698925801, 2699294669 fixed double save button issue
Sohel 01/16/2023 2698964415 fixed Fields payload Issue
sai krishna 01/16/2023 2698964415 add code and description ,type
Sohel 01/16/2023 2698964415 Fields Payload Changes
Sohel 01/16/2023 2698964415 fixed Function payload Issue
Sohel 01/16/2023 2698964415 rename placeholder
Sohel 01/17/2023 2698964415 changed Save button condition
Sohel 01/18/2023 2698964415 tooltip changes
Sohel 01/19/2023 2698964415 hide position field and conditional validation
Sohel 01/19/2023 2698964415 title changes
Sohel 01/19/2023 2699714747 Download Configuration payload changes
Sohel 01/20/2023 2698964415 Added Last Step in Stepper
Sohel 01/20/2023 2698964415 tooltip label changes
Sohel 01/23/2023 2698964415 Added Audit Fields
Dilip 01/23/2023 2698964415 changed search fields dialog box title
Sohel 01/25/2023 2698964415 completed Status changes
Sohel 01/25/2023 2698964415 Fixed Category population issue
Sai Maheshwar 01/27/2023 2699714747, 2701334326, 2817617043 added value field for CONSTANT function.
Ashraf 01/27/2023 2698964415 disabled audit field map
dilip 01/27/2023 2699714747 Changed Temporary Repo name
Sohel 01/31/2023 2698964415 payload changes
Dilip 02/01/2023 2698964415 code and description label changes
Sohel 02/01/2023 2698964415 set record Type
Sohel 02/06/2023 2698964415 disabled Save button
Sohel 02/08/2023 2701335619 Implement Usage Functionality
Dilip 02/08/2023 2698964415 Changed button labels and icons
Sohel 02/13/2023 2701335619 fixed unique field validation issue
Sohel 02/17/2023 2701335619 fixed Function Date Format Issue
suresh peddavoora 02/22/2023 2701335619 New UI changes fixed
Raghu 02/23/2023 2701335619 added new class for buttons
Ravi 03/02/2023 2701335619 Remove stagging from add staging repository field button
Sohel 02/03/2023 2701335619 header line changes
Sohel 03/06/2023 2701335619 changed staging repository to DB repository
Sohel 03/06/2023 2701335619 label changes
Dilip 03/08/2023 2701335619 disabled field position based on condition
Sohel 03/08/2023 2701335619 Field Position payload and added Validation condition
Sohel 03/15/2023 2701335619 hide Duplicate Criteria Based on condition
Sohel 03/16/2023 2701335619  Added TransForm Field in Fields Tab
Dilip 03/21/2023 2701335619 Fixed label changes.
Sohel 03/21/2023 2701335619 hide Logic Field Button
Sohel 03/24/2023 2701335619 Added Logic Field in Fields
Sohel 03/24/2023 2701335619 Fixed Map Field Checkbox Issue
Sohel 03/24/2023 2701335619 Fixed Closed and Save button Issue
Sohel 04/12/2023 2701335619 Added Logic Fields in Imports
Sohel 04/14/2023 2701335619 Added Map Field Fields FOr Exception Type
Sohel 04/19/2023 2698964415 Added Data Calculation Field
Sohel 04/19/2023 2698964415 Added Data Calculation Field
 Prakash 24/04/2023 2698964415 fixed button alignment issue for tab view
Sohel 06/03/2023 2698964415 Added Amount Format Field
Akhila 06/12/2023 2698964415 added role access
Sohel 06/03/2023 2701334326 Added Amount Format Field
Ravi 06/15/2023 2701335619 rename map fields title
Ravi 06/19/2023 2701335619 Added breadcrum in map field and data calculation
Sohel 06/19/2023 2701335619 change Temp Repo and Function repository name
Ravi 06/19/2023 2701335619 show data calculation title conditionally
Ravi 06/19/2023 2701335619 Added Breadcrum in data cal and map fields
Ravi 06/19/2023 2701335619 Added Breadcrum in popup
Sohel 06/21/2023 2701335619 Change Dialogue Box header
Ravi 06/23/2023 2701335619 fixed submit issue
Guru Prasad 09/22/2023 5152729171 Fixed enable and disabled fields issue in the table
Sohel 10/11/2023  2698964415 Change default filter condition
Dilip-pds 30/10/2023 2701335619 Fixed validation issue of field header.
Sohel 12/12/2023 2701335619 label name change code to name 
*/
import React, {useContext, useEffect, useRef, useState} from 'react';
import {Field, FieldArray, Form, Formik} from 'formik';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {Button, Tooltip} from '@material-ui/core';
import DialogBox from '../../../../../components/DialogBox';
import AddIcon from '@material-ui/icons/Add';
import RecordFormatFields, {showValue} from './RecordFormatFieldsComponents/RecordFormatFields';
import SearchFields from '../../../GlobalFields/DataRepositories/SearchDataRepositories/index';
import ExceptionRecordsTable from './ExceptionRecordsTable';
import {useSelector, useDispatch} from 'react-redux';
import {
  fetchDmFormats,
  fetchRecordFormatFieldsData,
  postRecordFormatFields,
  resetRecordFormatFields,
  fetchMasterRecordFormatFieldsData,
  setCategoryRedux,
  fetchBasicInfoData,
  fetchTranslationDropdownData,
} from '../../../../../redux/reducers/DataManagerRecord';
import * as Yup from 'yup';
import PageLoader from '../../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {
  DATA_UPDATE_FUNCTIONS,
  FOOTER_FUNCTIONS,
  HEADER_FUNCTIONS,
  NEW_ACCOUNT_FUNCTIONS,
  NEW_PAYMENT_FUNCTIONS,
  EXPORT_FUNCTIONS,
  EXCEPTION_FUNCTIONS,
} from '../../../../../constants/Lookup';
import {fetchFunctionList} from '../../../../../redux/reducers/lookupReducer';
import {resetBasicInfo} from '../../../../../redux/reducers/DataManagerRecord';
import BreadCrums from '../../../../../util/BreadCrum';
import SearchAuditFields from './AuditFields';
import {resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import SearchLogicField from './SearchLogicField';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';

// const dmRecordCategory = {
//   categoryCode: "D",
//   categoryName: "Debtor",
// }
const noDBFieldTypes = ['Header', 'Footer'];
const newBusinessRecords = ['New Account Import', 'New Payment Import'];
export const getLookupCode = (val) => {
  if (val === 'Header') {
    return HEADER_FUNCTIONS;
  } else if (val === 'Footer') {
    return FOOTER_FUNCTIONS;
  } else if (val === 'Data Update') {
    return DATA_UPDATE_FUNCTIONS;
  } else if (val === 'New Account Import') {
    return NEW_ACCOUNT_FUNCTIONS;
  } else if (val === 'New Payment Import') {
    return NEW_PAYMENT_FUNCTIONS;
  } else if (val === 'Data Export') {
    return EXPORT_FUNCTIONS;
  } else if (val === 'Exception') {
    return EXCEPTION_FUNCTIONS;
  }
  return null;
};
export const showRequiredValue = (current) =>
  current.mapFieldType === 'Function' &&
  current.fieldNames &&
  ['FIXED_TEXT', 'TIME', 'DATE_TIME', 'CONSTANT'].includes(current.fieldNames);
function DMRRecordFormatFields({
  handleBack,
  handleNext,
  exportManagerRecord,
  handleDirty,
  setValue,
  exceptionType,
  processor,
  hideFilterCriteriaRule = () => {},
  hideDuplicateCriteria = false,
  dmTempRecordAccess,
  editExisting,
}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [open, setOpen] = useState(false);
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const [logicFieldsOpen, setLogicFieldsOpen] = useState(false);
  const initialVal = {
    selectedFields: [],
  };
  const [initialValues, setInitialValues] = useState(initialVal);
  const type = exportManagerRecord ? 'Export' : 'Import';
  const dmArrayHelpers = useRef();
  const [deletedIds, setDeletedIds] = useState([]);
  const dispatch = useDispatch();
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const [auditFieldOpen, setAuditFieldOpen] = useState(false);
  const saveRef = useRef();
  const {functionsList, loading, error} = useSelector(({lookup}) => lookup);
  const [openException, setOpenException] = useState(false);
  const {
    isRecordFieldsLoading,
    recordFieldsSuccessMsg,
    recordFieldsErrorMsg,
    recordFieldsStatus,
    recordCode,
    dataManagerRecordId,
    fixedLength,
    recordFormatFieldsData,
    category,
    basicInfoData,
    basicInfoSuccessMsg,
    isBasicInfoLoading,
    isDraftRecord,
    headerLines,
  } = useSelector(({dataManagerRecord}) => dataManagerRecord);
  const {recordType} = useSelector(({dataManagerRecordGroup}) => dataManagerRecordGroup);
  // const recordType = useMemo(() => ({ value: basicInfoData?.recordType }), [basicInfoData]);
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);
  useEffect(() => {
    if (dataManagerRecordId) {
      dispatch(fetchBasicInfoData(dataManagerRecordId));
    }
  }, [dataManagerRecordId]);
  const categoryData = [
    {
      categoryCode: 'CO',
      categoryName: 'Core',
    },
  ];
  const handleLogicFieldsClose = () => {
    setLogicFieldsOpen(false);
  };
  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.value === option || item.key === option || item.categoryCode === option) {
          label = item;
        }
      });
    return label;
  };
  useEffect(() => {
    if (basicInfoSuccessMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
      }, 1500);
    }
  }, [basicInfoSuccessMsg]);
  const dbCategory = basicInfoData?.category ?
    getObject(basicInfoData?.category, categoryData) :
    {categoryCode: 'CO', categoryName: 'Core'};
  useEffect(() => {
    if ('category' in basicInfoData) {
      dispatch(setCategoryRedux({property: 'category', value: dbCategory}));
    }
  }, [basicInfoData?.category]);
  const validationSchema = Yup.object().shape({
    selectedFields: Yup.array().of(
      Yup.object().shape({
        fieldHeader:
          headerLines?.toString() === '0' && type === 'Import' ?
            '' :
            Yup.string().required('Field Header is required').nullable(),
        fieldPosition:
          basicInfoData?.dynamic === 'Y' ?
            '' :
            Yup.number()
              .transform((value) =>
                value === '' || value === null || value === undefined || isNaN(value) ?
                  undefined :
                  value,
              )
              .positive('Position cannot be negative or 0')
              .test('Field Position', 'Field Position is required', (value) => {
                if (!value && fixedLength !== 'Y') {
                  return false;
                } else {
                  return true;
                }
              })
              .test(
                'duplicate check',
                (path) => {
                  return `Field position ${path.value} is already defined`;
                },
                (value, context) => {
                  const form = context.from[1] || [];
                  const tempFieldPositions = form?.value?.selectedFields.filter(
                    (el) => value && el.fieldPosition?.toString() === value?.toString(),
                  );

                  if (
                    value &&
                      tempFieldPositions.length > 1 &&
                      (exportManagerRecord || exceptionType)
                  ) {
                    return false;
                  } else {
                    return true;
                  }
                },
              ),
        fieldLength:
          fixedLength === 'Y' &&
          Yup.number()
            .positive('Field length cannot be negative or 0')
            .test('Field Length', 'Field Length is required', (value) => {
              if (!value && fixedLength === 'Y') {
                return false;
              } else {
                return true;
              }
            }),
        startPosition:
          fixedLength === 'Y' &&
          Yup.number()
            .positive('Start position cannot be negative or 0')
            .test('Start Position', 'Start Position is required', (value) => {
              if (!value && fixedLength === 'Y') {
                return false;
              } else {
                return true;
              }
            }),
        fieldNames: Yup.mixed()
          .test('FieldName', 'Field Name is required', (value, ctx) => {
            if (
              !value &&
              (ctx.parent.mapFieldType === 'Temp Field' || ctx.parent.mapFieldType === 'Function')
            ) {
              return false;
            } else {
              return true;
            }
          })
          .test(
            'duplicate check',
            (path) => {
              return `Field name ${path.value} is already defined`;
            },
            (value, context) => {
              const form = context.from[1] || [];
              const tempFieldNames = form?.value?.selectedFields.filter(
                (el) =>
                  !['DB Field', 'Data Calculation Field', 'Audit Field']?.includes(
                    el.mapFieldType,
                  ) &&
                  context.originalValue === value &&
                  el?.mapFieldType === context?.parent?.mapFieldType &&
                  value &&
                  el.fieldNames === value,
              );
              const noDuplicateValidation = showValue(context.parent);

              if (value && tempFieldNames.length > 1 && !noDuplicateValidation) {
                return false;
              } else {
                return true;
              }
            },
          ),
        fieldValue: Yup.mixed().test('FieldValue', 'Value is required', (value, ctx) => {
          const noValidConstant = ctx?.parent?.fieldNames?.toLowerCase() !== 'constant';
          if (
            !value &&
            ctx.parent.mapFieldType === 'Function' &&
            showRequiredValue(ctx.parent) &&
            noValidConstant
          ) {
            return false;
          } else {
            return true;
          }
        }),
      }),
    ),
  });
  const columns = [
    {
      title: 'Actions',
    },
    {
      title: 'Field Type',
    },
    {
      title: 'Field Header',
      hidden: headerLines?.toString() === '0' && type === 'Import',
    },
    {
      title: 'Field Position',
      hidden: fixedLength === 'Y' || basicInfoData.dynamic === 'Y',
    },
    {
      title: 'Repository Name',
    },
    {
      title: 'Field Name',
    },
    {
      title: 'Value',
    },
    {
      title: 'Data Type',
    },
    {
      title: 'Start Position',
      hidden: fixedLength === 'N',
    },
    {
      title: 'Field Length',
      hidden: fixedLength === 'N',
    },
    {
      title: 'Format',
    },
    {
      title: 'Amount Format',
    },
    {
      title: 'Transform',
    },
  ];

  const onSubmit = (values) => {
    if (values?.selectedFields?.length > 0) {
      dispatch(submissionStart());
      const dmRecordFields = values?.selectedFields?.map((el) => {
        return {
          dataManagerRecordFieldId: el?.dataManagerRecordFieldId ? el?.dataManagerRecordFieldId : 0,
          fieldHeader: headerLines?.toString() === '0' && type === 'Import' ? '' : el?.fieldHeader,
          fieldLength: fixedLength === 'Y' ? el?.fieldLength : '',
          fieldPosition: basicInfoData?.dynamic === 'Y' ? '' : el?.fieldPosition,
          fieldType: el?.mapFieldType,
          format: el?.format === 'none' ? '' : el?.format || '',
          amountType: el?.dataType === 'Amount' ? (el?.amountType ? el?.amountType : 'With $') : '',
          recordCode: recordCode,
          repositoryFieldCode:
            el?.mapFieldType === 'Temp Field' || el?.mapFieldType === 'Function'
              ? el?.fieldNames
              : el?.fieldName,
          repositoryName: el?.repositoryName,
          dataType:
            el?.mapFieldType === 'Function'
              ? functionsList?.filter((e) => e.value === el.fieldNames)[0]?.dataType || ''
              : el.dataType,
          startPosition: fixedLength === 'Y' ? el?.startPosition : '',
          fieldValue:
            el?.mapFieldType === 'Function' && el?.fieldNames === 'DATE'
              ? el.fieldValue
                ? el.dateType + el.fieldValue
                : 'T'
              : el.fieldValue
                ? el.fieldValue
                : '',
          processorFieldId: el?.processorFieldId ? el?.processorFieldId : 0,
          transformCode: el?.transform === 'none' ? '' : el?.transform || '',
          dataRepoFieldId: el?.repositoryFieldId ? el?.repositoryFieldId : el?.dataRepoFieldId ? el?.dataRepoFieldId : 0,
          dataRepoId: el?.dataRepositoryId ? el?.dataRepositoryId : el?.dataRepoId ? el?.dataRepoId : 0,
        };
      });
      const payload = {
        deletedDmRecordFormatFieldIds: deletedIds?.length > 0 ? [...new Set(deletedIds)] : [0],
        dmRecordFieldRequests: dmRecordFields,
        dataManagerRecordId:dataManagerRecordId ? dataManagerRecordId : 0,
        recordCode: recordCode,
        fileType: type,
        lastStep:
          isDraftRecord === 'N' ?
            basicInfoData?.lastStep :
            exceptionType ?
              1 :
              saveRef.current ?
                basicInfoData?.lastStep :
                2,
        isDraft:
          basicInfoData?.masterRecord === 'Y' && !hideDuplicateCriteria ?
            isDraftRecord === 'N' ?
              'N' :
              'Y' :
            'N',
      };
      dispatch(postRecordFormatFields(payload));
    }
  };
  const handleClose = () => {
    setOpen(false);
    setAuditFieldOpen(false);
    setOpenException(false);
  };

  useEffect(() => {
    if (recordType) {
      const lookupCode = getLookupCode(recordType?.value);
      if (lookupCode) {
        dispatch(fetchFunctionList(lookupCode));
      }
    }
    dispatch(fetchDmFormats());
  }, [recordType]);
  useEffect(() => {
    if (basicInfoData?.masterRecord && exceptionType) {
      dispatch(fetchMasterRecordFormatFieldsData('Import', basicInfoData?.masterRecord));
    }
  }, [basicInfoData]);

  useEffect(() => {
    if (recordFormatFieldsData?.length > 0) {
      const data = recordFormatFieldsData?.map((el) => {
        return {
          mapFieldType: el?.fieldType,
          repositoryName: el?.repositoryName,
          fieldName: el?.repositoryFieldCode,
          fieldHeader: el?.fieldHeader,
          fieldPosition: el?.fieldPosition,
          startPosition: fixedLength === 'Y' ? el?.startPosition : null,
          fieldLength: fixedLength === 'Y' ? el?.fieldLength : null,
          format: el?.format === '' ? 'none' : el?.format || '',
          amountType:
            el?.amountType === '' ? 'none' : el?.dataType === 'Amount' ? el?.amountType : '',
          dataType: el.dataType,
          dataManagerRecordFieldId: el?.dataManagerRecordFieldId ? el?.dataManagerRecordFieldId : 0,
          fieldNames: el?.repositoryFieldCode,
          fieldValue:
            el?.fieldType === 'Function' && el?.repositoryFieldCode === 'DATE'
              ? el.fieldValue?.replace(/\D/g, '')
              : el.fieldValue
                ? el.fieldValue
                : '',
          isEditable: el?.isEditable,
          processorFieldId: el?.processorFieldId ? el?.processorFieldId : 0,
          dateType:
            el?.fieldType === 'Function' && el?.repositoryFieldCode === 'DATE'
              ? el?.fieldValue === 'T'
                ? 'T + '
                : el?.fieldValue?.replace(/[0-9]/g, '')
              : '',
          transform: el?.transformCode === '' ? 'none' : el?.transformCode || '',
          dataRepoFieldId: el?.dataRepoFieldId ? el?.dataRepoFieldId : 0,
          dataRepoId: el?.dataRepoId ? el?.dataRepoId : 0,
        };
        // dmArrayHelpers.current.push(value)
      });
      // setSelectedRows(data);
      setInitialValues({...initialValues, selectedFields: data});
    }
  }, [recordFormatFieldsData]);
  useEffect(() => {
    if (recordFieldsErrorMsg || recordFieldsSuccessMsg) {
      setTimeout(() => {
        if (recordFieldsStatus === 200 && !saveRef.current && recordFieldsSuccessMsg) {
          exceptionType ? setValue(0) : handleNext();
        }
        dispatch(resetRecordFormatFields());
      }, 1500);
    }
  }, [recordFieldsErrorMsg, recordFieldsSuccessMsg]);

  useEffect(() => {
    if (recordFieldsStatus === 200 && recordFieldsSuccessMsg) {
      dispatch(fetchRecordFormatFieldsData(type, dataManagerRecordId));
    }
  }, [recordFieldsStatus, recordFieldsSuccessMsg]);

  useEffect(() => {
    if (dataManagerRecordId) {
      dispatch(fetchRecordFormatFieldsData(type, dataManagerRecordId));
    }
  }, [dataManagerRecordId]);

  // function getLookupData(code) {
  //   if (lookupData && code in lookupData) {
  //     return lookupData[code];
  //   } else {
  //     return null;
  //   }
  // }

  // const functionsList =[]
  // getLookupData(getLookupCode(recordType.value) && getLookupCode(recordType.value)[0]) || [];

  useEffect(() => {
    dispatch(fetchTranslationDropdownData());
  }, []);

  const getFieldPosition = (values) => {
    const fieldPositionArr = values.selectedFields.map((item) => {
      return item.fieldPosition ? Number(item.fieldPosition) : 0;
    });
    const maxFieldPosition = fieldPositionArr?.length > 0 ? Math.max(...fieldPositionArr) : 0;
    return maxFieldPosition + 1;
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={(values) => onSubmit(values)}
        validateOnChange
      >
        {(props) => {
          const {values, setFieldValue, submitForm, dirty} = props;
          handleDirty && handleDirty(dirty);
          const hideFilterCriteria = values?.selectedFields?.filter(
            (el) => el?.repositoryName === 'Account' && el?.fieldName === 'Account Number',
          );
          hideFilterCriteriaRule(hideFilterCriteria?.length > 0);
          return (
            <>
              <Form noValidate>
                <FieldArray
                  name="selectedFields"
                  render={(arrayHelpers) => {
                    dmArrayHelpers.current = arrayHelpers;
                    return (
                      <>
                        <div>
                          <BreadCrums
                            name={
                              exportManagerRecord ?
                                'Export Template Record Name' :
                                'Import Template Record Name'
                            }
                            code={basicInfoData?.recordCode}
                            description={
                              exportManagerRecord ?
                                'Export Template Record Description' :
                                'Import Template Record Description'
                            }
                            descriptionValue={basicInfoData?.recordDescription}
                            returnType={'Type'}
                            returnTypeValue={basicInfoData?.recordType || ''}
                          />
                        </div>
                        <div
                          className={
                            exportManagerRecord ?
                              'table-header justify-content-end new-standard-textfields exporttemplate-buttons' :
                              'table-header justify-content-end new-standard-textfields'
                          }
                        >
                          {exportManagerRecord ||
                          ['Data Update', 'New Account Import']?.includes(recordType?.value) ? (
                              <Button
                                variant="outlined"
                                className={`search-btn mx-1 ${classes.buttonRoot}`}
                                onClick={() => setLogicFieldsOpen(true)}
                                startIcon={<AddIcon />}
                              >
                              Data Calculations Fields
                              </Button>
                            ) : null}

                          {noDBFieldTypes.includes(recordType?.value) ? null : (
                            <Button
                              variant="outlined"
                              className={`search-btn mx-1 ${classes.buttonRoot}`}
                              onClick={() => {
                                setOpen(true);
                              }}
                              startIcon={<AccountTreeIcon />}
                            >
                              Map Fields
                            </Button>
                          )}
                          {!exceptionType ? (
                            <Button
                              variant="outlined"
                              className={`search-btn mx-1 ${classes.buttonRoot}`}
                              onClick={() => {
                                const tempFields = {
                                  fieldType: '',
                                  repositoryName: 'TEMPORARY_REPO',
                                  fieldName: '',
                                  fieldHeader: '',
                                  fieldPosition: getFieldPosition(values),
                                  startPosition: '',
                                  fieldLength: '',
                                  format: '',
                                  fieldNames: '',
                                  mapFieldType: 'Temp Field',
                                  value: '',
                                  dataType: 'Text',
                                  fieldValue: '',
                                  transform: '',
                                  amountType: '',
                                };
                                arrayHelpers.push(tempFields);
                              }}
                            >
                              <AddIcon />
                              Temp Field
                            </Button>
                          ) : (
                            <Button
                              variant="outlined"
                              className={`search-btn ml-1 ${classes.buttonRoot} mr-2`}
                              onClick={() => {
                                setOpenException(true);
                              }}
                            >
                              <AddIcon />
                              Record Field
                            </Button>
                          )}
                          {!processor && (
                            <Button
                              variant="outlined"
                              className={`search-btn mx-1 ${classes.buttonRoot}`}
                              onClick={() => {
                                const functionFields = {
                                  repositoryName: 'FUNCTION',
                                  fieldName: '',
                                  fieldHeader: '',
                                  fieldPosition: getFieldPosition(values),
                                  startPosition: '',
                                  fieldLength: '',
                                  format: '',
                                  fieldNames: '',
                                  value: '',
                                  mapFieldType: 'Function',
                                  dataType: '',
                                  fieldValue: '',
                                  dateType: 'T + ',
                                  transform: '',
                                  amountType: '',
                                };
                                arrayHelpers.push(functionFields);
                              }}
                            >
                              <AddIcon />
                              Function
                            </Button>
                          )}
                          {exportManagerRecord && basicInfoData?.includeAudit === 'Y' && (
                            <Button
                              variant="outlined"
                              className={`search-btn mx-1 ${classes.buttonRoot}`}
                              onClick={() => setAuditFieldOpen(true)}
                              startIcon={<AddIcon />}
                            >
                              Audit Fields
                            </Button>
                          )}
                        </div>
                        <div
                          className={
                            'mui-custom-table-container custom-table  pt-0 global-field-table text-center-table new-standard-textfields newTableColumn'
                          }
                        >
                          <table>
                            <thead className="recFormat-header-container">
                              <tr>
                                {columns.map(
                                  ({title, hidden = false}) =>
                                    !hidden && (
                                      <th key={title} className="recFormat-header">
                                        {title}
                                      </th>
                                    ),
                                )}
                              </tr>
                            </thead>
                            {values.selectedFields?.length > 0 ? (
                              <tbody className="recFormat-body">
                                {values.selectedFields.map((field, index) => (
                                  <>
                                    <Field
                                      key={field.fieldName + field.repositoryName}
                                      name={`selectedFields[${index}]`}
                                      component={RecordFormatFields}
                                      index={index}
                                      columns={columns}
                                      dmArrayHelpers={dmArrayHelpers}
                                      deletedIds={deletedIds}
                                      setDeletedIds={setDeletedIds}
                                      functionsList={functionsList || []}
                                      type={type}
                                      dmTempRecordAccess={dmTempRecordAccess}
                                      editExisting={editExisting}
                                    />
                                  </>
                                ))}
                              </tbody>
                            ) : (
                              <tbody>
                                <tr>
                                  <td colSpan={columns.length}>
                                    {recordType?.value === 'Exception' ?
                                      'No records to display. To add fields to your record add atleast 1 record field or function field.' :
                                      ['Data Export', 'Data Update', 'Customer Query']?.includes(
                                        recordType?.value,
                                      ) ?
                                        'No records to display. To add fields to your record add atleast 1 data repository field, temp field or function field.' :
                                        newBusinessRecords.includes(recordType?.value) ?
                                          'No records to display. To add fields to your record add atleast 1 repository field, temp field or function field.' :
                                          'No records to display. To add fields to your record add atleast 1 temp field or function field.'}
                                  </td>
                                </tr>
                              </tbody>
                            )}
                          </table>
                        </div>
                        <DialogBox
                          open={openException}
                          dialogClose={handleClose}
                          // title={"Search Import Manager Record Fields"}
                          title={
                            <div className="dialog-breadcrum">
                              <p className="dialoge-title-breadcrum">
                                <b>Search Import Manager Record Fields</b>
                              </p>
                              <BreadCrums
                                name={'Import Template Record Name'}
                                code={basicInfoData?.recordCode}
                                description={'Import Template Record Description'}
                                descriptionValue={basicInfoData?.recordDescription}
                              />
                            </div>
                          }
                          maxWidth="xl"
                        >
                          <div>
                            <ExceptionRecordsTable
                              tempSelectedRows={tempSelectedRows}
                              handleClose={handleClose}
                              setFieldValue={setFieldValue}
                              dmValues={values}
                              dmArrayHelpers={dmArrayHelpers}
                              setTempSelectedRows={setTempSelectedRows}
                              deletedIds={deletedIds}
                              setDeletedIds={setDeletedIds}
                            />
                          </div>
                        </DialogBox>
                        <DialogBox
                          open={open}
                          dialogClose={handleClose}
                          title={
                            <div className="dialog-breadcrum">
                              <p className="dialoge-title-breadcrum">
                                <b>Map Fields</b>
                              </p>
                              <BreadCrums
                                name={`${type} Template Record Name`}
                                code={basicInfoData?.recordCode}
                                description={`${type} Template Record Description`}
                                descriptionValue={basicInfoData?.recordDescription}
                              />
                            </div>
                          }
                          maxWidth="xl"
                        >
                          <div>
                            <SearchFields
                              tempSelectedRows={tempSelectedRows}
                              handleClose={handleClose}
                              setTempSelectedRows={setTempSelectedRows}
                              setDMFieldValue={setFieldValue}
                              dmValues={values}
                              dmArrayHelpers={dmArrayHelpers}
                              deletedIds={deletedIds}
                              setDeletedIds={setDeletedIds}
                              isReports={true}
                              mapFields={true}
                              moduleName={exportManagerRecord ? 'EXPORT' : 'IMPORT'}
                              dmRecordCategory={category}
                              isDataManager={true}
                              exceptionType={exceptionType}
                              getFieldPosition={getFieldPosition}
                            />
                          </div>
                        </DialogBox>
                        <DialogBox
                          open={auditFieldOpen}
                          dialogClose={handleClose}
                          // title="Search Audit Fields"
                          title={
                            <div className="dialog-breadcrum">
                              <p className="dialoge-title-breadcrum">
                                <b>Search Audit Fields</b>
                              </p>
                              <BreadCrums
                                name={'Export Template Record Name'}
                                code={basicInfoData?.recordCode}
                                description={'Export Template Record Description'}
                                descriptionValue={basicInfoData?.recordDescription}
                              />
                            </div>
                          }
                          maxWidth="xl"
                        >
                          <SearchAuditFields
                            setAuditFieldValue={setFieldValue}
                            dmValues={values}
                            setTempSelectedRows={setTempSelectedRows}
                            tempSelectedRows={tempSelectedRows}
                            handleClose={handleClose}
                            dmRecordCategory={category}
                            deletedIds={deletedIds}
                            setDeletedIds={setDeletedIds}
                            isRecordFormat={true}
                          />
                        </DialogBox>
                        <DialogBox
                          open={logicFieldsOpen}
                          dialogClose={handleLogicFieldsClose}
                          // title="Search Data Calculations Fields"
                          title={
                            <div className="dialog-breadcrum">
                              <p className="dialoge-title-breadcrum">
                                <b>Search Data Calculations Fields</b>
                              </p>
                              <BreadCrums
                                name={
                                  exportManagerRecord ?
                                    'Export Template Record Name' :
                                    'Import Template Record Name'
                                }
                                code={basicInfoData?.recordCode}
                                description={
                                  exportManagerRecord ?
                                    'Export Template Record Description' :
                                    'Import Template Record Description'
                                }
                                descriptionValue={basicInfoData?.recordDescription}
                              />
                            </div>
                          }
                          maxWidth="xl"
                        >
                          <SearchLogicField
                            setAuditFieldValue={setFieldValue}
                            dmValues={values}
                            setTempSelectedRows={setTempSelectedRows}
                            tempSelectedRows={tempSelectedRows}
                            handleClose={handleLogicFieldsClose}
                            dmRecordCategory={category}
                            deletedIds={deletedIds}
                            setDeletedIds={setDeletedIds}
                            isRecordFormat={true}
                            getFieldPosition={getFieldPosition}
                          />
                        </DialogBox>
                      </>
                    );
                  }}
                />

                <div className="new-standard-textfields d-flex justify-content-center mt-3">
                  {handleNext && (
                    <Button
                      type="button"
                      onClick={() => {
                        handleBack && handleBack();
                      }}
                      variant="outlined"
                      className={`mx-1 reset-btn ${classes.buttonRoot}`}
                    >
                      Back
                    </Button>
                  )}
                  {/* && isDraftRecord === "N" */}
                  {values?.selectedFields?.length > 0 ? (
                    <Button
                      variant="outlined"
                      type="button"
                      className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                      disabled={(editExisting && !dmTempRecordAccess?.edit) || enabledSubmission}
                      onClick={() => {
                        saveRef.current = true;
                        handleDirty(false, 'fixed');
                        submitForm();
                      }}
                    >
                      Save
                    </Button>
                  ) : (
                    <Tooltip
                      title={
                        recordType?.value === 'Exception' ?
                          'Please add atleast one record field or function field' :
                          ['Data Export', 'Data Update', 'Customer Query']?.includes(
                            recordType?.value,
                          ) ?
                            'Please add atleast one repository field, temp field or function field' :
                            newBusinessRecords.includes(recordType?.value) ?
                              'Please add atleast one repository field, temp field or function field' :
                              'Please add atleast one temp field or function field'
                      }
                    >
                      <span>
                        <Button
                          variant="outlined"
                          type="button"
                          className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                          disabled
                        >
                          Save
                        </Button>
                      </span>
                    </Tooltip>
                  )}
                  {values?.selectedFields?.length > 0 && !processor ? (
                    <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn ${classes.buttonRoot}`}
                      disabled={(editExisting && !dmTempRecordAccess?.edit) || enabledSubmission}
                      onClick={() => {
                        saveRef.current = false;
                        submitForm();
                      }}
                    >
                      {exceptionType ? 'Finish' : handleNext ? 'Save & Next' : 'Save'}
                    </Button>
                  ) : (
                    !processor && (
                      <Tooltip
                        title={
                          recordType?.value === 'Exception' ?
                            'Please add atleast one record field or function field' :
                            ['Data Export', 'Data Update', 'Customer Query']?.includes(
                              recordType?.value,
                            ) ?
                              'Please add atleast one repository field, temp field or function field' :
                              newBusinessRecords.includes(recordType?.value) ?
                                'Please add atleast one repository field, temp field or function field' :
                                'Please add atleast one temp field or function field'
                        }
                      >
                        <span>
                          <Button
                            type="submit"
                            variant="outlined"
                            className={`mx-1 search-btn ${classes.buttonRoot}`}
                            disabled
                          >
                            {exceptionType ? 'Finish' : 'Save & Next'}
                          </Button>
                        </span>
                      </Tooltip>
                    )
                  )}
                </div>
              </Form>
            </>
          );
        }}
      </Formik>
      {(isRecordFieldsLoading || loading || isBasicInfoLoading || printUsageIsLoading) && (
        <PageLoader />
      )}
      {(recordFieldsErrorMsg || error || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={recordFieldsErrorMsg || error || printUsageErrorMsg} />
      )}
      {(recordFieldsSuccessMsg || basicInfoSuccessMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar
          successMsg={basicInfoSuccessMsg || recordFieldsSuccessMsg || printUsageSuccessMsg}
        />
      )}
    </>
  );
}
export default DMRRecordFormatFields;
